const firebaseMiddleware = () => (next) => (action) => next(action);

export default firebaseMiddleware;
